export const pollyLanguageList = [
  {
    name: 'Arabic',
    code: 'arb',
  },
  {
    name: 'Catalan',
    code: 'ca-ES',
  },
  {
    name: 'Chinese, Cantonese',
    code: 'yue-CN',
  },
  {
    name: 'Chinese, Mandarin',
    code: 'cmn-CN',
  },
  {
    name: 'Danish',
    code: 'da-DK',
  },
  {
    name: 'Dutch',
    code: 'nl-NL',
  },
  {
    name: 'English, American',
    code: 'en-US',
  },
  {
    name: 'English, Australian',
    code: 'en-AU',
  },
  {
    name: 'English, British',
    code: 'en-GB',
  },
  {
    name: 'English, Indian',
    code: 'en-IN',
  },
  {
    name: 'English, New Zealand',
    code: 'en-NZ',
  },
  {
    name: 'English, South African',
    code: 'en-ZA',
  },
  {
    name: 'English, Welsh (en',
    code: 'GB-WLS',
  },
  {
    name: 'French',
    code: 'fr-FR',
  },
  {
    name: 'French, Canadian',
    code: 'fr-CA',
  },
  {
    name: 'German',
    code: 'de-DE',
  },
  {
    name: 'German, Austrian',
    code: 'de-AT',
  },
  {
    name: 'Hindi',
    code: 'hi-IN',
  },
  {
    name: 'Icelandic',
    code: 'is-IS',
  },
  {
    name: 'Italian',
    code: 'it-IT',
  },
  {
    name: 'Japanese',
    code: 'ja-JP',
  },
  {
    name: 'Korean',
    code: 'ko-KR',
  },
  {
    name: 'Norwegian',
    code: 'nb-NO',
  },
  {
    name: 'Polish',
    code: 'pl-PL',
  },
  {
    name: 'Portuguese',
    code: 'pt-PT',
  },
  {
    name: 'Portuguese, Brazilian',
    code: 'pt-BR',
  },
  {
    name: 'Romanian',
    code: 'ro-RO',
  },
  {
    name: 'Russian',
    code: 'ru-RU',
  },
  {
    name: 'Spanish',
    code: 'es-ES',
  },
  {
    name: 'Spanish, Mexican',
    code: 'es-MX',
  },
  {
    name: 'Spanish, US',
    code: 'es-US',
  },
  {
    name: 'Swedish',
    code: 'sv-SE',
  },
  {
    name: 'Turkish',
    code: 'tr-TR',
  },
  {
    name: 'Welsh',
    code: 'cy-GB',
  },
];
